import React, {Component} from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {Card, CardBody, Col, Row, Progress, Alert} from "reactstrap";
import {
  getSurveyResponse,
  postSurveyResponse,
  postQuestionResponses,
  getQuestionsListPreview
} from "../../reducers/surveyResponse/actions";
import {updateCurrent} from "../../reducers/progress/actions";
import {getCurrentMicroTime} from "../../reducers/timeMeasuring/actions";
import Page from "../Page/index";
import PageEnd from "../PageEnd/index";
import axios from "axios";
import LoadingSpinner from "components/LoadingSpinner";
import SurveyLang from "components/SurveyLang";
import Footer from "../Footer";
import {browserName, browserVersion, osName, osVersion, mobileModel} from "react-device-detect";
import api from "../../api";
import Parser from 'react-html-parser';
import scrollToComponent from 'react-scroll-to-component';
import ErrorPage from "../ErrorPage";
import ConfirmPasswordPage from "../ConfirmPasswordPage";
import {isMobile, isTablet, isBrowser} from "react-device-detect";
import classnames from "classnames";
import Navigation from './components/Navigation';
import SocialMediaShares from "./components/SocialMediaShares";
import SurveyHeader from "./components/SurveyHeader";
import SurveyFooter from "./components/SurveyFooter";
import BlockName from "./components/BlockName";
import {injectIntl} from "react-intl";
import SurveyReport from "../../components/SurveyReport";
import SurveyDarkMode from "../../components/SurveyDarkMode";
import SurveyBodyInvitation from "./components/SurveyBodyInvitation";
import isValidationEnabled from "../../utils/isValidationEnabled";
import LoginPage from "../../components/LoginPage";
import {setSurveyNavHideValidation} from "../../reducers/surveyNav/actions";
import {useParams} from "react-router";
import sendMessageToPreview from "../../utils/sendMessageToPreview";

function withParams(Component) {
  return props => <Component {...props} params={useParams()} />;
}

class Survey extends Component {

  constructor(props) {
    super(props);

    this.block = false;
    const url = new URL(window.location.href);
    let forcePageEnd = false;
    url.searchParams.forEach((value, key) => {
      if(key === 'endingpage' && value){
        forcePageEnd = true;
      }
    })

    this.state = {
      loginRequired: false,
      surveyName: '',
      loadingSurvey: true,
      loadingPages: true,
      pageIndex: 0,
      responseError: false,
      nextSurveys: [],
      passwordConfirmed: false,
      lastDisplayProgress: 0,
      forcePageEnd: forcePageEnd
    };

    this.page = React.createRef();
    this.handlerChangePage = this.handlerChangePage.bind(this);
    this.surveyBody = this.surveyBody.bind(this);
    this.getProgress = this.getProgress.bind(this);
    this.renderProgress = this.renderProgress.bind(this);
    this.handleQuestionResponse = this.handleQuestionResponse.bind(this);
    this.isProperDevice = this.isProperDevice.bind(this);
    this.isAbleToRenderSocialShares = this.isAbleToRenderSocialShares.bind(this);
    this.addScrollClassToBody = this.addScrollClassToBody.bind(this);
    Survey.renderLogo = Survey.renderLogo.bind(this);
  }

  componentDidCatch(error, errorInfo) {
    const {survey} = this.props;
  }

  handleScroll(event) {
    if (this.block) {
      this.block = false;
      return
    }

    let scrollTop = document.body.scrollTop;
    const scrollHeight = document.querySelector("body").offsetHeight;
    const rootHeight = document.getElementById('root').offsetHeight;
    let percent = scrollTop * 100 / (scrollHeight - rootHeight) * -1;
    percent = Math.round(percent);

    if (window.self !== window.top) {
      window.parent.postMessage(percent, "*");
    }
  }

  handleOnMessage(event) {
    if (Number.isInteger(event.data)) {
      this.block = true;
      const scrollHeight = document.querySelector("body").offsetHeight;
      const rootHeight = document.getElementById('root').offsetHeight;
      let scroll = rootHeight - scrollHeight;
      let offset = scroll * event.data * 0.01;
      document.body.scrollTop = offset;
    }
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleOnMessage);
    window.removeEventListener('scroll', this.handleScroll, true);
  }

  componentDidMount(){
    const url = new URL(window.location.href);
    let questionsListPreview = false;
    window.addEventListener('message', this.handleOnMessage);
    window.addEventListener('scroll', this.handleScroll, true);

    url.searchParams.forEach((value, key) => {
      if(key === 'questionsListPreview' && parseInt(value) === 1){
        questionsListPreview = true;
      }
    })

    if(questionsListPreview){
      this.props.getQuestionsListPreview({
        guid: this.props.params.guid,
      }).then(data => {
        this.setState({
          loadingSurvey: false,
          loadingPages: false,
          responseError: false,
        });
      }).catch(res => {
        this.setState({
          loadingSurvey: false,
          loadingPages: false,
          responseError: res.response
        });
      });
    }else{
      if('srId' in this.props.params){
        axios.defaults.headers.common.surveyResponseKey = this.props.params.surveyResponseKey;

        this.props.getSurveyResponse({
          surveyResponseId: this.props.params.srId,
        }).then(data => {
          this.setState({
            loadingSurvey: false,
            loadingPages: false,
            responseError: false,
          });

          if(data && data.nextSurveys){
            this.setState({
              nextSurveys: data.nextSurveys
            });
          }

          if(data && data.response){
            this.setState({
              responseError: data.response
            });
          }
        }).catch(res => {
          if(res.response.status === 401){
            this.setState({
              loginRequired: true,
              surveyName: res.response.data.surveyName,
            })
            // window.location = '/logowanie?_target_path=' + window.location.pathname;
          }else{
            this.setState({
              loadingSurvey: false,
              loadingPages: false,
              responseError: res.response
            });
          }
        });
      }else{
        let params = {};
        let qr = {};

        url.searchParams.forEach((value, key) => {
          if(key === 'params'){
            params['params'] = value;
          }
          var regex = /(params\[)([a-zA-Z0-9\-_]+)+/g;
          var res = regex.exec(key);
          if(res){
            params[res[2]] = value;
          }else{
            params[key] = value;
          }

          //qr[xx]=yy
          var regex = /(qr\[)([a-zA-Z0-9\-_]+)+/g;
          var res = regex.exec(key);
          if(res){
            qr[res[2]] = value;
          }
        });

        let data = {
          guid: this.props.params.guid,
          subguid: this.props.params.subguid || null,
          questionId: url.searchParams.get('question'),
          edit: url.searchParams.get('edit'),
          surveyResponseId: url.searchParams.get('id'),
          pausedResponseId: this.props.params.pausedResponseId,
          refId: url.searchParams.get('ref_by_uid'),
          isMobile: url.searchParams.get('auth'),
          success: url.searchParams.get('success'),
          qr,
        };

        if(url.searchParams.get('from')){
          data.from = url.searchParams.get('from');
        }

        this.props.postSurveyResponse(data).then(data => {
          if (this.props.survey.hardData) {
            api.surveyResponse.respondent.browserInfo({
              surveyResponseId: data.surveyResponse.id,
              browser: {
                browserName,
                browserVersion,
                osName,
                mobileModel: mobileModel !== 'none' ? mobileModel : null,
              }
            });
          }

          if(!_.isEmpty(params)){
            api.surveyResponse.patch.params({
              surveyResponseId: data.surveyResponse.id,
              params,
            });
          }

          if(data && data.nextSurveys){
            this.setState({
              nextSurveys: data.nextSurveys
            });
          }

          this.setState({
            loadingSurvey: false,
            loadingPages: false,
            responseError: false,
          });


          if (data && data.questionPreview) {
            scrollToComponent(this.page.current.refs['question-' + data.questionPreview], { align: 'top', offset: -30 });
          }

          if(data && data.response){
            this.setState({
              responseError: data.response
            });
          }
        }).catch(res => {
          if(res.response.status === 401){
            this.setState({
              loginRequired: true,
              surveyName: res.response.data.surveyName,
            })
            // window.location = '/logowanie?_target_path=' + window.location.pathname;
          }else{
            this.setState({
              loadingSurvey: false,
              loadingPages: false,
              responseError: res.response
            });
          }
        });
      }
    }
  }

  handlerChangePage(direction, skipValidate = false){
    const url = new URL(window.location.href.toLowerCase());
    const {collector} = this.props.surveyResponse;
    if(direction < 0){
      skipValidate = true;
    }

    if(!isValidationEnabled()){
      skipValidate = true;
    }

    if (this.page.current) {
      this.props.setSurveyNavHideValidation(false)
      const pageValidate = this.page.current.validate();
      if(!skipValidate && !pageValidate.valid){
        var element = document.getElementById('question-' + pageValidate.questions[0]);
        element.scrollIntoView({behavior:"smooth", block: "start", inline:"nearest"});
        sendMessageToPreview(true)

        return false;
      }
    }

    const questionResponses = _.filter(this.props.questionResponses, questionResponse => {
      return this.props.pages[this.state.pageIndex] && this.props.pages[this.state.pageIndex].questions.find(question => parseInt(question.id) === parseInt(questionResponse.question));
    });

    let newIndex = this.state.pageIndex;
    if (this.props.surveyResponse.status !== 1 || !this.props.surveyResponse.invitationText) {
      newIndex += direction;
    }

    const microTime = this.props.pages.length === 0 ? 0 : getCurrentMicroTime(this.props.startTime);
    if(newIndex in this.props.pages){
      this.setState({
        pageIndex: newIndex,
      });
      this.props.updateCurrent(direction);

      var root = document.getElementById('root');
      root.scrollIntoView({behavior:"instant", block: "start", inline:"nearest"});

      this.props.postQuestionResponses({
        surveyResponseId: this.props.surveyResponse.id,
        questionResponses,
        microTime,
      })
        .catch(res => {
          this.setState({
            loadingPages: false
          });
        });
      sendMessageToPreview();
    }else{
      const lastIndex = this.state.pageIndex;

      this.setState({ loadingPages: true });

      if (direction === 1) {
        this.setState({pageIndex: 0});
      }

      this.props.postQuestionResponses({
        surveyResponseId: this.props.surveyResponse.id,
        _direction: direction,
        questionResponses,
        microTime,
      }).then(data => {
        this.setState({
          loadingPages: false,
          pageIndex: direction < 0 ? data.pages.length-1 : 0,
          nextSurveys: data.nextSurveys
        });

        sendMessageToPreview();
      }).catch(() => {
        this.setState({
          pageIndex: lastIndex,
          loadingPages: false
        });
      })
      ;
    }
  }

  handleQuestionResponse() {
    const questionResponses = _.filter(this.props.questionResponses, questionResponse => {
      return this.props.pages[this.state.pageIndex] && this.props.pages[this.state.pageIndex].questions.find(question => parseInt(question.id) === parseInt(questionResponse.question));
    });

    const microTime = getCurrentMicroTime(this.props.startTime);

    this.props.postQuestionResponses({
      surveyResponseId: this.props.surveyResponse.id,
      _direction: 0,
      questionResponses,
      microTime
    });
  }

  surveyBody(){
    const {loadingPages, pageIndex, forcePageEnd} = this.state;
    const {pages, surveyResponse, intl} = this.props;

    if(loadingPages){
      return <LoadingSpinner/>
    }

    if(surveyResponse.isEnded || forcePageEnd){
      return <div><PageEnd nextSurveys={this.state.nextSurveys}/></div>;
    }

    if(surveyResponse.status === 1 && surveyResponse.invitationText){
      return <SurveyBodyInvitation />;
    }

    if(!_.isEmpty(pages)){
      return <div><Page ref={this.page} intl={intl} changePage={this.handlerChangePage} page={pages[pageIndex]} handleQuestionResponse={this.handleQuestionResponse}/></div>
    }

    if(!surveyResponse.isEnded && _.isEmpty(pages)){
      return <SurveyBodyInvitation />;
    }
  }

  isAbleToRenderSocialShares(){
    const {pages, surveyResponse} = this.props;

    if (surveyResponse.collector.type === 'WebLink' || surveyResponse.collector.type === 'Temporary') {
      if (surveyResponse.isEnded) {
        return true;
      }

      if (!surveyResponse.isEnded && _.isEmpty(pages)) {
        return true;
      }
    }

    return false;
  }

  addScrollClassToBody() {
    const {pageIndex} = this.state;
    const {pages} = this.props;
    const currentPage = pages[pageIndex];

    let isScrollQuestion = false;

    const body = document.querySelector("body");
    const html = document.querySelector("html");

    if (currentPage && currentPage.questions.length > 0) {
      currentPage.questions.map((question) => {
        if (question.type === 'basket' || question.presentationType === "dragAndDrop") {
          isScrollQuestion = true;
        }
      })

      if (isScrollQuestion) {
        body.className = "scrollable";
        html.className = "scrollable"
        return
      }
    }
    body.className = "";
    html.className = ""
  }

  renderProgress(surveyResponse){
    const {pageIndex, lastDisplayProgress} = this.state;
    const {progress, pages} = this.props;
    if (!progress || progress.empty) {
      return;
    }
    const position = (pages.length <= pageIndex || pages.length <= 0) ? 1 : (progress.pageOrder.indexOf(pages[pageIndex].id) + 1)
    let progressValue = Math.floor((position / progress.pageOrder.length) * 100)
    let displayProgressValue = lastDisplayProgress;

    const progressEl = document.querySelector("#main-progress .progress-bar");
    if (progressEl) {
      const ariaValueNow = progressEl.getAttribute("aria-valuenow");
      if (progressValue < ariaValueNow) {
        progressValue = ariaValueNow;
      }
    }

    if (pages.length > 100) {
      let newDisplayProgress = ((position / progress.pageOrder.length) * 100).toFixed(1);
      if ((newDisplayProgress*10) > (lastDisplayProgress*10)) {
        displayProgressValue = newDisplayProgress;
        this.setState({
          lastDisplayProgress: displayProgressValue
        })
      }
    } else {
      if (progressValue > lastDisplayProgress) {
        displayProgressValue = progressValue;
        this.setState({
          lastDisplayProgress: displayProgressValue
        })
      }
    }

    return this.props.survey.progressBar.visible === true && progress.max > 1 ? ((!surveyResponse.isEnded && !_.isEmpty(pages)) && <Progress id={"main-progress"} value={progressValue}><span class={"progress-value"} style={{fontSize: "16px"}}>{displayProgressValue}%</span></Progress>) : ('')
  }

  static renderLogo(survey){
    return <React.Fragment>
      {survey.logo.image && <img src={survey.logo.image} className="display-light survey-logo mw-100" alt="Logo image"/>}
      {(survey.logo.image || survey.logo.darkModeImage) && <img src={survey.logo.darkModeImage ? survey.logo.darkModeImage : survey.logo.image} className="survey-logo mw-100 display-dark" alt="Logo image"/>}
    </React.Fragment>


    return survey.logo.image !== undefined ? (<img src={survey.logo.image} className="survey-logo mw-100" alt="Logo image"/>) : ('')
  }

  getProgress(){
    const {progress} = this.props;

    return progress.current === 0 ? 0 : parseInt((progress.current / progress.max) * 100);
  }

  isAndroidWebview() {
    const normalizedUserAgent = navigator.userAgent.toLowerCase();
    const isAndroid = /android/.test(normalizedUserAgent);
    return (isAndroid && /; wv\)/.test(normalizedUserAgent))
  }

  isIosWebview() {
    return /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(navigator.userAgent);
  }


  isProperDevice() {
    const {survey} = this.props;

    if (survey.ios && this.isIosWebview()) {
      return true;
    }

    if (survey.android && this.isAndroidWebview()) {
      return true;
    }

    return ((survey.phone && isMobile) || (survey.tablet && isTablet) || (survey.desktop && (!isMobile && !isTablet))) && (survey.maxScreenWidth === 0 || screen.width < survey.maxScreenWidth)
  }

  render() {
    // if(this.state.hasError){
    //   return <Alert color="danger">Podczas zapisu odpowiedzi wystąpił błąd. Informacje o błędzie zostały zapisane i zostaną przeanalizowane przez nasz zespół.</Alert>
    // }

    const {loadingSurvey, loadingPages, loginRequired, pageIndex, responseError, passwordConfirmed, forcePageEnd} = this.state;
    const {survey, surveyResponse, pages} = this.props;

    if(loginRequired){
      return <LoginPage
        surveyName={this.state.surveyName}
        onSuccess={() => {
          window.location.reload();
        }}
      />
    }

    if(loadingSurvey){
      return <LoadingSpinner/>
    }

    if(responseError){
      return <ErrorPage responseError={responseError} />
    }

    if (survey.passwordBlockade && !passwordConfirmed) {
      return <ConfirmPasswordPage surveyId={survey.id} handleSuccess={() => this.setState({passwordConfirmed: true})}/>
    }

    if (!this.isProperDevice()) {
      let properDevices = [];
      properDevices.push("")
      if(survey.phone){ properDevices.push(this.props.intl.formatMessage({id: 'survey.device-phone'})) }
      if(survey.tablet){ properDevices.push(this.props.intl.formatMessage({id: 'survey.device-tablet'})) }
      if(survey.desktop){ properDevices.push(this.props.intl.formatMessage({id: 'survey.device-desktop'})) }
      if(survey.android){ properDevices.push(this.props.intl.formatMessage({id: 'survey.device-android'})) }
      if(survey.ios){ properDevices.push(this.props.intl.formatMessage({id: 'survey.device-ios'})) }

      let message = [this.props.intl.formatMessage({id: 'survey.notProperDevice'})];
      message.push(this.props.intl.formatMessage({id: 'survey.properDevices'}));
      message.push(properDevices.join('<br>'));

      const error = {
        data: {
          msg: message.join(' ')
        },
        status: 404
      };

      return <ErrorPage responseError={error} />
    }

    const progressValue = this.getProgress();
    const surveyLangVisible = !surveyResponse.isEnded && survey.languages.length > 1;
    this.addScrollClassToBody();

    return (
      <div>
        <Navigation response={surveyResponse} pages={pages}/>
        <SurveyHeader survey={survey}/>

        <header>
          {(survey.logo.image || survey.logo.darkModeImage) && <Row className={"mt-3 mb-3"}>
            {Survey.renderLogo(survey)}
          </Row>}
          <Row>
            <Col className="d-flex align-items-center" sm={12}>
              <div className={classnames({
                'ml-auto w-100': true
              })}>
              {this.props.survey.progressBar.placement === 'header' && this.renderProgress(surveyResponse)}
              </div>
              {surveyLangVisible && <div className="ml-2 survey-lang"><SurveyLang /></div>}
              {this.props.survey.darkModeAvailable && <div className="ml-2"><SurveyDarkMode /></div>}
              <div className="d-block"><SurveyReport pageIndex={pageIndex}><i className="fas fa-exclamation-circle ml-2 mt-2 cursor-pointer" /></SurveyReport></div>
            </Col>
          </Row>
          <div className={"survey-name"}>{survey.nameOryginal}</div>
        </header>

        {surveyResponse.status === 2 && <BlockName page={pages[pageIndex]} />}

        {this.surveyBody()}

        {(!surveyResponse.isEnded && !forcePageEnd) && <Footer disableButtons={loadingPages} pageIndex={pageIndex} onChangePage={(direction) => this.handlerChangePage(direction)} />}
        {this.props.survey.progressBar.placement === 'footer' && <Row className="mb-3 justify-content-end"><Col xs={12}>{this.renderProgress(surveyResponse)}</Col></Row>}
        <SurveyFooter survey={survey}/>
        {this.isAbleToRenderSocialShares() && <SocialMediaShares survey={survey} surveyResponse={surveyResponse}/>}
      </div>
    )
  }
}

Survey.propTypes = {
  surveyResponse: PropTypes.shape({
    collector: PropTypes.shape({
      type: PropTypes.string,
      enabledSurveyFilters: PropTypes.bool,
      enabledValidations: PropTypes.bool,
    }),
  }),
  questionResponses: PropTypes.objectOf(PropTypes.shape({
    question: PropTypes.number.isRequired,
    details: PropTypes.array.isRequired,
    microTime: PropTypes.number.isRequired,
  })).isRequired,
  intl: PropTypes.object.isRequired,
  survey: PropTypes.shape({
    darkModeAvailable: PropTypes.bool.isRequired,
  }).isRequired,
};

function mapStateToProps(state) {
  return {
    survey: state.surveyResponse.survey,
    pages: state.pages,
    surveyResponse: state.surveyResponse,
    questionResponses: state.questionResponses,
    progress: state.progress,
    startTime: state.timeMeasuring.startTime,
  }
}

export default withParams(connect(mapStateToProps, {setSurveyNavHideValidation, getQuestionsListPreview, getSurveyResponse, postSurveyResponse, postQuestionResponses, updateCurrent}, null, {forwardRef: true})(injectIntl(Survey)));
